import Papa from 'papaparse';
import './App.css';
import csvFile from './config/mapRedirect.csv';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';

const defaultURL = 'https://pnnl.sharepoint.com/teams/EARRTH/';

const spinnerStyles = {
  circle: {
    height: 75,
    width: 75,
    borderWidth: 10,
    color: 'white'
  }
}

function App() {

  const doRedirect = (newUrl) => {
    window.location.replace(newUrl);
  }

  const redirect = () => {

    let oldUrl = window.location.href;

    if (oldUrl.includes('DocIdRedir')) {
      getNewUrl();
    } else {
      doRedirect(defaultURL);
    }
  }

  const getNewUrl = () => {

    let oldUrl = window.location.href;
    let baseUrl = window.location.origin;

    /**
     * for dev and test purposes
     */

    if (
      oldUrl.startsWith('http://localhost:3000') ||
      oldUrl.startsWith('https://testearrth.pnl.gov') ||
      oldUrl.startsWith('https://fakeearrth.pnnl.gov')
    ) {

      oldUrl = oldUrl.replace(baseUrl, 'https://earrth.pnnl.gov');
    }

    Papa.parse(csvFile, {
      download: true,
      header: true,
      complete: function (input) {
        const mappingData = input.data;

        const mappedUrl = mappingData
          .filter((mapping) => oldUrl.toString().startsWith(mapping['Old URL String'].toString()))
          .reduce((mostMatchedUrl, currentMatchedUrl) => currentMatchedUrl['Old URL String'].toString().length > mostMatchedUrl['Old URL String'].toString().length ? currentMatchedUrl : mostMatchedUrl, { 'Old URL String': '' });
        
        if (!!mappedUrl['Old URL String']) {
          const newUrl = oldUrl.replace(mappedUrl['Old URL String'], mappedUrl['New URL String']);

          doRedirect(newUrl);

        } else {

          doRedirect(defaultURL);
        }

      }
    });
  }

  return (
    <div className="App">
      <header className="App-header">
        <div className='Main-Body'>
          <h2>
            The website you are attempting to access has moved. 
            <br/>
            Please wait while you are being redirected.

          </h2>
        </div>
        <Spinner styles={spinnerStyles} size={SpinnerSize.large} />
        <p>
          If you have any questions please contact the Techdesk
          <br />
          Phone: <a href="tel:5093756789">509-375-6789</a>
          <br />
          Site:  <a href="https://techdesk.pnnl.gov">https://techdesk.pnnl.gov</a>
          <br />
          Email: <a href="mailto:techdesk@pnnl.gov">techdesk@pnnl.gov</a>
        </p>
      </header>
      {
        redirect()
      }
    </div>
  );
}

export default App;
